import { api } from "@/api/axios.ts";
import { ApiOperationResult } from "@/types/common.types.ts";
import {
  ApiEmployeeCustomTableEditPayload,
  ApiEmployeeCustomTableRowPrefill,
  ApiEmployeeCustomTableSearchResult,
} from "@/types/employees/employee.types.ts";
import { ApiFilterBase } from "@skailer-com/uikit/core";
import { GenericAbortSignal } from "axios";

export const apiEmployeeCustomTable = {
  search(employeeId: number, tableId: number, filter: ApiFilterBase) {
    return api.post<ApiEmployeeCustomTableSearchResult>(
      `/api/v1/employees/${employeeId}/field-tables/${tableId}/search`,
      filter
    );
  },
  getNewRowPrefill(
    employeeId: number,
    tableId: number,
    effectiveFrom: string | null,
    signal?: GenericAbortSignal
  ) {
    return api.get<ApiEmployeeCustomTableRowPrefill>(
      `/api/v1/employees/${employeeId}/field-tables/${tableId}/rows/prefill`,
      effectiveFrom ? { effective_from: effectiveFrom } : {},
      signal
    );
  },
  addRow(employeeId: number, tableId: number, payload: ApiEmployeeCustomTableEditPayload) {
    return api.post<ApiOperationResult>(
      `/api/v1/employees/${employeeId}/field-tables/${tableId}/rows`,
      payload
    );
  },
  updateRow(
    employeeId: number,
    tableId: number,
    rowId: number,
    payload: ApiEmployeeCustomTableEditPayload
  ) {
    return api.put<ApiOperationResult>(
      `/api/v1/employees/${employeeId}/field-tables/${tableId}/rows/${rowId}`,
      payload
    );
  },
  deleteRow(employeeId: number, tableId: number, rowId: number) {
    return api.delete<ApiOperationResult>(
      `/api/v1/employees/${employeeId}/field-tables/${tableId}/rows/${rowId}`
    );
  },
};
